import moment from 'moment';

export default function formatDate(value: any, formatString: string) {
    if (!value) {
        return '';
    }
    return moment.utc(value).utcOffset('+07:00').format(formatString ? formatString : 'DD-MM-YYYY HH:mm:ss');
}
